import React, { Component } from 'react';
import moment from 'moment';

import CheckingOffensesModel from './CheckingOffensesModel';

import { Badge, message } from 'antd';

class CheckingNumberOfOffenses extends Component {

    state = {
        data: null
    }

    componentWillMount() {
        CheckingOffensesModel.getAll(
            this.props.record.locationId,
            moment(this.props.record.timestamp).startOf('day').utc().format(),
            moment(this.props.record.timestamp).endOf('day').utc().format(),
            this.props.record.plate
        )
            .then((data) => {
                this.setState({
                    data
                });
            })
            .catch(err => {
                message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.');
            });
    }

    onClickImg(base64data) {
        var newTab = window.open('', '_blank', "menubar=no,status=no,titlebar=no,location=no,toolbar=no,scrollbars=yes,resizable=yes,top=50,left=500,width=640,height=480");
        newTab.document.body.innerHTML = '<img src="' + base64data + '">';
    }

    render() {
        if (!this.state.data) {
            return this.props.record.plate;
        } else if (this.state.data !== null && this.state.data.length < 2) {
            return this.props.record.plate;
        } else {
            return (
                <Badge count={(this.state.data.length - 1)} style={{ fontSize: 10, minWidth: 15, height: 15, lineHeight: '15px' }}><div style={{ paddingLeft: 0, paddingRight: 10 }}>{this.props.record.plate}</div></Badge>
            );
        }
    }
}

export default CheckingNumberOfOffenses;


// WEBPACK FOOTER //
// ./src/components/CheckingNumberOfOffenses.js